import React from "react";
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Evenement = ({ evenement }) => {
    const navigate = useNavigate();
    const isJoueur = evenement.hasOwnProperty('pseudo');

    const calculerAffichageTemps = () => {
        const dateActuelle = new Date();
        if (!isJoueur && evenement.dateFin) {
            const dateFin = new Date(evenement.dateFin);
            dateFin.setHours(23, 59, 59, 999);
            if (dateFin < dateActuelle) {
                return "TERMINÉ";
            }
        }

        let dateEvenement;
        if (isJoueur) {
            const anniversaire = new Date(evenement.anniversaire);
            dateEvenement = new Date(dateActuelle.getFullYear(), anniversaire.getMonth(), anniversaire.getDate());
            if (dateEvenement < dateActuelle) {
                dateEvenement.setFullYear(dateActuelle.getFullYear() + 1);
            }
        } else {
            dateEvenement = new Date(evenement.date);
        }

        const diffTemps = dateEvenement - dateActuelle;
        const jours = Math.ceil(diffTemps / (1000 * 60 * 60 * 24));
        return jours <= 0 ? "NOW" : jours;
    };

    const tempsAffichage = calculerAffichageTemps();
    const isNow = tempsAffichage === "NOW";
    const isTermine = tempsAffichage === "TERMINÉ";

    const handleClick = () => {
        if (evenement.cliquable === false) {
            return;
        }

        if (!isJoueur) {
            if (evenement.titre === 'LCK Road to MSI') {
                navigate('/lck-road-to-msi');
            } else if (evenement.titre.includes('LCK')) {
                navigate('/lck');
            } else if (evenement.titre === 'MSI') {
                navigate('/msi');
            } else {
                navigate(`/evenement/${evenement.titre}`);
            }
        }
    };

    const isClickable = evenement.cliquable !== false;

    return (
        <div
            onClick={handleClick}
            className={`
                relative flex items-center justify-between bg-[#1A1A1A] bg-opacity-70 px-3 md:px-6 py-4 rounded-lg
                transition-all duration-300 flex-shrink
                ${isClickable
                    ? 'hover:bg-[#222222] hover:bg-opacity-90 hover:shadow-lg cursor-pointer'
                    : 'cursor-not-allowed'}
                ${isNow ? 'border-2 border-red-500 animate-pulse-border' : ''}
                ${isTermine ? 'opacity-60' : ''}
            `}
        >
            {isNow && (
                <div className="absolute top-0 left-0 bg-red-500 text-white text-[8px] font-bold px-1 py-0.5 rounded-sm shadow-lg z-10 leading-none">
                    NOW
                </div>
            )}
            {isTermine && (
                <div className="absolute top-0 left-0 bg-gray-500 text-white text-[8px] font-bold px-1 py-0.5 rounded-sm shadow-lg z-10 leading-none">
                    FIN
                </div>
            )}

            <div className="flex items-center gap-6">
                <img
                    src={process.env.PUBLIC_URL + (isJoueur ? `/images/minijoueurs/${evenement.pseudo}.jpg` : `/images/evenements/${evenement.logo}`)}
                    alt={isJoueur ? evenement.nom : evenement.titre}
                    className="w-10 h-10 rounded-md object-contain"
                />
                <div className="flex flex-col text-left">
                    <h1 className="text-white font-semibold text-lg font-poppins">{isJoueur ? evenement.pseudo : evenement.titre}</h1>
                    <h2 className="text-gray-400 text-sm font-poppins">{isJoueur ? evenement.anniversaire : evenement.lieu}</h2>
                </div>
            </div>

            <div className="flex flex-col text-right pl-4 md:pl-16 items-center min-w-[60px] md:min-w-[80px]">
                <h1 className={`font-bold font-poppins ${isNow ? "text-white text-xl" : isTermine ? "text-gray-400 text-sm" : "text-white text-2xl"}`}>
                    {isTermine ? "TERMINÉ" : tempsAffichage}
                </h1>
                {!isNow && !isTermine && (
                    <h2 className="text-gray-400 text-sm font-poppins">
                        jour{tempsAffichage !== 1 ? 's' : ''}
                    </h2>
                )}
            </div>
        </div>
    );
};

Evenement.propTypes = {
    evenement: PropTypes.shape({
        titre: PropTypes.string.isRequired,
        lieu: PropTypes.string.isRequired,
        logo: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
    }).isRequired,
}

export default Evenement;